/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */

export let canvas: HTMLCanvasElement = null;
export let gl: WebGLRenderingContext = null;
export let s_instance: LAppGlManager = null;

/**
 * Cubism SDKのサンプルで使用するWebGLを管理するクラス
 */
export class LAppGlManager {
  /**
   * クラスのインスタンス（シングルトン）を返す。
   * インスタンスが生成されていない場合は内部でインスタンスを生成する。
   *
   * @return クラスのインスタンス
   */
  public static getInstance(): LAppGlManager {
    if (s_instance == null) {
      s_instance = new LAppGlManager();
    }

    return s_instance;
  }

  /**
   * クラスのインスタンス（シングルトン）を解放する。
   */
  public static releaseInstance(): void {
    if (s_instance != null) {
      s_instance.release();
    }

    s_instance = null;
  }

  constructor() {
    // キャンバスの作成
    canvas = document.createElement('canvas');

    // glコンテキストを初期化 (with retry logic)
    this.initializeWebGL();
  }

  /**
   * Initialize WebGL context with retry logic
   */
  private initializeWebGL(retryCount: number = 0): void {
    const maxRetries = 5;
    const retryDelayMs = 500;

    // @ts-ignore
    gl = canvas.getContext('webgl2');

    if (!gl) {
      // Try webgl1 as fallback
      // @ts-ignore
      gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    }

    if (!gl) {
      if (retryCount < maxRetries) {
        console.warn(`WebGL not ready, retrying... (${retryCount + 1}/${maxRetries})`);
        setTimeout(() => {
          this.initializeWebGL(retryCount + 1);
        }, retryDelayMs);
        return;
      }

      // All retries exhausted
      console.error('Cannot initialize WebGL after multiple attempts.');
      gl = null;
      // Don't show alert or replace body - let the app handle gracefully
    } else {
      console.log('WebGL initialized successfully' + (retryCount > 0 ? ` after ${retryCount} retries` : ''));
    }
  }

  /**
   * 解放する。
   */
  public release(): void {}
}
